"use strict";
// iban-validate.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.ibanToFriendly = exports.ibanToElectronic = exports.IBAN_LEN = void 0;
exports.ibanMod97IsValid = ibanMod97IsValid;
exports.validateIbanValue = validateIbanValue;
exports._IsIbanValid = _IsIbanValid;
exports.IBAN_LEN = {
    AD: 24,
    AE: 23,
    AL: 28,
    AT: 20,
    AZ: 28,
    BA: 20,
    BE: 16,
    BG: 22,
    BH: 22,
    BR: 29,
    BY: 28,
    CH: 21,
    CR: 22,
    CY: 28,
    CZ: 24,
    DE: 22,
    DK: 18,
    DO: 28,
    EE: 20,
    ES: 24,
    FI: 18,
    FO: 18,
    FR: 27,
    GB: 22,
    GE: 22,
    GI: 23,
    GL: 18,
    GR: 27,
    GT: 28,
    HR: 21,
    HU: 28,
    IE: 22,
    IL: 23,
    IQ: 23,
    IS: 26,
    IT: 27,
    JO: 30,
    KW: 30,
    KZ: 20,
    LB: 28,
    LC: 32,
    LI: 21,
    LT: 20,
    LU: 20,
    LV: 21,
    MC: 27,
    MD: 24,
    ME: 22,
    MK: 19,
    MR: 27,
    MT: 31,
    MU: 30,
    NL: 18,
    NO: 15,
    PK: 24,
    PL: 28,
    PS: 29,
    PT: 25,
    QA: 29,
    RO: 24,
    RS: 22,
    SA: 24,
    SE: 24,
    SI: 19,
    SK: 24,
    SM: 27,
    TL: 23,
    TN: 24,
    TR: 26,
    UA: 29,
    VA: 22,
    VG: 24,
    XK: 20,
};
var ibanToElectronic = function (v) { return (v !== null && v !== void 0 ? v : '').toUpperCase().replace(/[^A-Z0-9]/g, ''); };
exports.ibanToElectronic = ibanToElectronic;
var ibanToFriendly = function (e) { return e.replace(/(.{4})/g, '$1 ').trim(); };
exports.ibanToFriendly = ibanToFriendly;
function ibanMod97IsValid(electronic) {
    if (electronic.length < 5)
        return false;
    if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(electronic))
        return false;
    var cc = electronic.slice(0, 2);
    var expected = exports.IBAN_LEN[cc];
    if (expected && electronic.length !== expected)
        return false;
    var rearranged = electronic.slice(4) + electronic.slice(0, 4);
    var remainder = 0;
    for (var _i = 0, rearranged_1 = rearranged; _i < rearranged_1.length; _i++) {
        var ch = rearranged_1[_i];
        if (ch >= '0' && ch <= '9') {
            remainder = (remainder * 10 + (ch.charCodeAt(0) - 48)) % 97;
        }
        else {
            var val = ch.charCodeAt(0) - 55; // A=10..Z=35
            remainder = (remainder * 10 + Math.floor(val / 10)) % 97;
            remainder = (remainder * 10 + (val % 10)) % 97;
        }
    }
    return remainder === 1;
}
/**
 * Validate a value that may be friendly-formatted or electronic.
 * Returns both `electronic` + `friendly` plus a state + translation keys.
 */
function validateIbanValue(value) {
    var electronic = (0, exports.ibanToElectronic)(value);
    var friendly = (0, exports.ibanToFriendly)(electronic);
    if (!electronic) {
        return { state: 'empty', electronic: '', friendly: '', hintKey: 'IBAN_HINT_START' };
    }
    if (electronic.length < 2) {
        return { state: 'hint', electronic: electronic, friendly: friendly, hintKey: 'IBAN_HINT_COUNTRY' };
    }
    var cc = electronic.slice(0, 2);
    if (!/^[A-Z]{2}$/.test(cc)) {
        return { state: 'invalid', electronic: electronic, friendly: friendly, errorKey: 'IBAN_ERROR_COUNTRY_CODE_LETTERS' };
    }
    var expected = exports.IBAN_LEN[cc];
    if (!expected) {
        return { state: 'invalid', electronic: electronic, friendly: friendly, errorKey: 'IBAN_ERROR_COUNTRY_UNKNOWN' };
    }
    if (electronic.length === 2) {
        return { state: 'hint', electronic: electronic, friendly: friendly, hintKey: 'IBAN_HINT_AFTER_COUNTRY' };
    }
    if (electronic.length < 4) {
        return { state: 'hint', electronic: electronic, friendly: friendly, hintKey: 'IBAN_HINT_CHECK_DIGITS' };
    }
    if (!/^\d{2}$/.test(electronic.slice(2, 4))) {
        return { state: 'invalid', electronic: electronic, friendly: friendly, errorKey: 'IBAN_ERROR_CHECK_DIGITS' };
    }
    if (electronic.length > expected) {
        return { state: 'invalid', electronic: electronic, friendly: friendly, errorKey: 'IBAN_ERROR_TOO_LONG' };
    }
    if (electronic.length < expected) {
        return {
            state: 'progress',
            electronic: electronic,
            friendly: friendly,
            cc: cc,
            current: electronic.length,
            expected: expected,
        };
    }
    // exact length reached: verify checksum
    var ok = ibanMod97IsValid(electronic);
    if (ok) {
        return { state: 'valid', electronic: electronic, friendly: friendly, cc: cc, expected: expected };
    }
    // keep previous behavior: checksum failure shows an error immediately (even on input)
    return { state: 'invalid', electronic: electronic, friendly: friendly, errorKey: 'IBAN_INVALID', alwaysError: true };
}
/** Convenience for submit checks */
function _IsIbanValid(value) {
    return validateIbanValue(value).state === 'valid';
}
